const constants = {
  actionGoToScreenId: 1,
}

export {constants}